import CenterCardLayout from './CenterCardLayout';
import useTranslation from '../hooks/useTranslation';

export function Error500Message() {
  const { t } = useTranslation();
  return (
    <CenterCardLayout>
      <>
        <h1>{t('Something went wrong')}</h1>
        <div className="d-grid">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => window.location.reload()}
          >
            {t('Reload')}
          </button>
        </div>
      </>
    </CenterCardLayout>
  );
}

export default Error500Message;
